import { Controller, SubmitHandler, useForm } from "react-hook-form";
import * as auth from '../../../store/actions/auth.action';
import { useState } from "react";
import { getLocalStorageValue } from "utils/handler";


interface FormInputType {
    budget: number;
    comments: string;
}

const TestForm: React.FC<{ showFaqModal: boolean, setShowFaqModal: (x: boolean) => void }> = ({ showFaqModal, setShowFaqModal }): JSX.Element => {

    const [isSubmitting, setIsSubmitting] = useState(false);
    const [result, setResult] = useState<any>(null);

    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm<FormInputType>({ mode: "onSubmit" });


    const onSubmit: SubmitHandler<FormInputType> = async (data) => {
        console.log("****************Form Data:", data);

        setIsSubmitting(true);
        try {
            const newLeadRes = await auth.testTempApi({
                budget: data.budget.toString(),
                comment: data.comments
            });
            console.log("API Response:", newLeadRes);
            setResult(newLeadRes)
        } catch (error) {
            console.error("Submission error:", error);
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="rewamp-form">
            <form className="form" onSubmit={handleSubmit(onSubmit)}>

                <div className="form-group">
                    <input type="text" {...register("budget", {
                        required: "Budget is required",
                        valueAsNumber: true,
                        validate: {
                            // 1. Only digits (Manual check since pattern hates numbers)
                            onlyNumbers: (v) => /^[0-9]+(\.[0-9]+)?$/.test(v?.toString()) || "Only whole numbers are allowed",

                            // 2. Your specific floor logic
                            // floor: (v) => (v >= 300) || "Budget must be at least $300",

                            // 3. Your specific ceiling logic
                            troll: (v) => (v < 1000000000) || "Budget cannot exceed $1 Billion"
                        }
                    })}
                        inputMode="numeric" placeholder="Approximate Budget*" />
                    {errors.budget && <span className="field-error">{errors.budget.message}</span>}
                </div>

                <div className="form-group">
                    <textarea {...register("comments", {
                        maxLength: {
                            value: 500,
                            message: "Comments can't exceed 500 characters"
                        },
                        required: "Comments are required",
                    })} placeholder="Comments" rows={4}></textarea>
                    {errors.comments && <span className="field-error">{errors.comments.message}</span>}
                </div>

                <button type="submit" disabled={isSubmitting}>{isSubmitting ? "Submitting..." : "Submit Request"}</button>

                {result && <>
                    <div>Results:</div>
                    <div>Approved: {result.approved ? "Yes" : "No"}</div>
                    <div>Reason: {result.reason || ""}</div>
                    <div>Score: {result.score || ""}</div>
                </>
                }

            </form>

        </div>
    )
}

export default TestForm;